import { useMemo } from "react";
import { useLocation } from "react-router";
import { useIntl, defineMessages } from "react-intl";
import { Wrapper } from "../components/layout/wrapper";
import ContactForm from "../components/contact-form";
import SpriteIcon from "../components/medias/sprite-icon";
import EditorialSeo from "../components/layout/editorial-seo";
import { CmsPageContent, extractCmsContent } from "@shared/graphql";
import { useAppConfig } from "@ct-react/core";
import { useQuery } from "@apollo/client/react";
import { useLocaleContext } from "@ct-react/locale";
import { gql } from "@apollo/client";
import Banner from "../components/layout/wrapper/banner";
import { getPageDataByPath } from "@shared/cms";
import NotFoundPage from "./not-found";

import "./contact.scss";

const transDefs = defineMessages({
    form_title: { id: "contact.form-title", defaultMessage: "Formulaire de contact" },
    form_contact_us: { id: "contact.form-contact-us", defaultMessage: "Contactez-nous" },
    form_schedule: { id: "contact.form-schedule", defaultMessage: "Nos horaires d’ouverture" },
    form_schedule_week: { id: "contact.form-schedule-week", defaultMessage: "Du Lundi au Vendredi" },
    form_schedule_week_schedule: { id: "contact.form-schedule-week-schedule", defaultMessage: "De 8h30 à 12h00 et de 13h30 à 18h00." },
    form_schedule_saturday: { id: "contact.form-schedule-saturday", defaultMessage: "Le Samedi en haute saison" },
    form_schedule_saturday_schedule: { id: "contact.form-schedule-saturday-schedule", defaultMessage: "De 8h30 à 12h00 et de 14h00 à 18h00." },
    form_schedule_sunday: { id: "contact.form-schedule-sunday", defaultMessage: "Dimanche et jours fériés fermés." },
});

const CMS_PAGE_GQL_DATA = gql`
  query ContactPageCmsPage($templateId: UUID!) {
    cmsPages(templateId: $templateId) { data }
  }
`;

const Contact = () => {
  const intl = useIntl();
  const { locale } = useLocaleContext();
  const { pathname } = useLocation();

  const { options: { cmsTemplates: { editorial: templateId } } } = useAppConfig();

  const { data,loading } = useQuery<{ cmsPages: any }>(CMS_PAGE_GQL_DATA, {
    ssr: true,
    variables: { templateId }
  });

  const cmsContent = useMemo<CmsPageContent | undefined>(() => {
    if (!data?.cmsPages?.length) return undefined;
    const page = getPageDataByPath(data.cmsPages, pathname);
    return page ? extractCmsContent(page, locale) : undefined;
  }, [ data, pathname, locale ]);

  if (!loading && Array.isArray(data?.cmsPages) && !cmsContent) return <NotFoundPage />;

  const seo = cmsContent?.["seo-data"];

  return(
    <>

      <EditorialSeo page="contact" seo={seo} />

      <Banner loading={loading} data={cmsContent} />

      <Wrapper.TwoCol as="section"
                      className="contact"
                      title={intl.formatMessage(transDefs.form_title)}>
        <Wrapper.ColText>
          <ContactForm data={{
            articleId: "",
            period: undefined
          }} />
        </Wrapper.ColText>
        <Wrapper.ColImage>
          <h3>{intl.formatMessage(transDefs.form_contact_us)}</h3>
          <address>
              <a href="https://maps.app.goo.gl/zPr4Hegvw7EqCehE9" target="_blank" rel="noopener noreferrer">
                <SpriteIcon hash="contact.pin-location"/>
                Route de la Télécabine 3<br/>
                1997 Haute-Nendaz
              </a>
              <a href="tel:0041272882319">
                <SpriteIcon hash="contact.phone"/>
                +41 27 288 23 19
              </a>
              <a href="mailto:info@inter-agence.ch">
                <SpriteIcon hash="contact.email"/>
                info@inter-agence.ch
              </a>
          </address>
          <div className="social">
            <a href="https://www.facebook.com/InterAgenceNendaz/" className="icone primary" target="_blank">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
                <path d="M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z"/>
              </svg>
            </a>
          </div>
          <h3>{intl.formatMessage(transDefs.form_schedule)}</h3>
            <p>{intl.formatMessage(transDefs.form_schedule_week)}</p>
            <p>{intl.formatMessage(transDefs.form_schedule_week_schedule)}</p>
            <br/>
            <p>{intl.formatMessage(transDefs.form_schedule_saturday)}</p>
            <p>{intl.formatMessage(transDefs.form_schedule_saturday_schedule)}</p>
            <br/>
            <p>{intl.formatMessage(transDefs.form_schedule_sunday)}</p>
        </Wrapper.ColImage>
      </Wrapper.TwoCol>
    </>
  )
};

export default Contact;
